module.exports = __webpack_public_path__ + "static/media/t53.734fd1bd.jpg";